import * as React from 'react';

export default function QuestionMarkCircle({
  className,
  viewBox = '0 0 120 120',
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg className={className} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108 60C108 86.5097 86.5097 108 60 108C33.4903 108 12 86.5097 12 60C12 33.4903 33.4903 12 60 12C86.5097 12 108 33.4903 108 60ZM60.0001 42C57.7868 42 55.8456 43.1953 54.7991 45.0044C53.1398 47.8727 49.4695 48.8529 46.6011 47.1936C43.7327 45.5344 42.7526 41.864 44.4118 38.9956C47.5151 33.6311 53.33 30 60.0001 30C69.9412 30 78.0001 38.0589 78.0001 48C78.0001 55.8373 72.9912 62.5047 66.0001 64.9758V66C66.0001 69.3137 63.3138 72 60.0001 72C56.6864 72 54.0001 69.3137 54.0001 66V60C54.0001 56.6863 56.6864 54 60.0001 54C63.3138 54 66.0001 51.3137 66.0001 48C66.0001 44.6863 63.3138 42 60.0001 42ZM60 90C63.3137 90 66 87.3137 66 84C66 80.6863 63.3137 78 60 78C56.6863 78 54 80.6863 54 84C54 87.3137 56.6863 90 60 90Z"
        fill="currentColor"
      />
    </svg>
  );
}
